export default __webpack_public_path__ + "images/bar-chart-dummy-140.ee24864aa8d0a16ee91ba5c3a384bcf0.svg";